import {
    FETCH_BRANDS,
    FETCH_FULL_BRAND,
    SAVE_BRAND,
    UPLOAD_BRAND_ASSET,
    REMOVE_BRAND_ASSET,
    UPDATE_BRAND,
    UPDATE_BRAND_THEME
} from '../types';
import api from '../api';

export const fetchBrands = (branchId, chainId) => {
    return {
        type: FETCH_BRANDS,
        payload: api.brands.getBrands(chainId, branchId)
    };
};

export const fetchFullBrandData = (brandKey, platform, onSuccess) => {
    return {
        type: FETCH_FULL_BRAND,
        payload: api.brands.get(brandKey, platform),
        meta: { onSuccess }
    };
};

export const saveBrand = (brand, onSuccess) => {
    return {
        type: SAVE_BRAND,
        payload: api.brands.create(brand),
        meta: { onSuccess }
    };
};

export const uploadBrandAsset = (brandKey, assetKey, file, keyPath) => {
    const data = new FormData();
    data.append('file', file);
    data.append('name', file.name);

    return {
        type: UPLOAD_BRAND_ASSET,
        payload: api.brands.createAsset(brandKey, assetKey, data),
        meta: { keyPath, brandKey }
    };
};

export const removeBrandAsset = (brandKey, assetKey, keyPath) => {
    return {
        type: REMOVE_BRAND_ASSET,
        payload: api.brands.deleteAsset(brandKey, assetKey),
        meta: { keyPath, brandKey }
    };
};

export const updateTheme = (brandKey, theme, platform) => {
    return dispatch => {
        dispatch({
            type: UPDATE_BRAND_THEME,
            payload: api.brands.updateTheme(brandKey, theme, platform),
            meta: { dispatchOnError: () => fetchFullBrandData(brandKey, platform) }
        });

        dispatch({
            type: UPDATE_BRAND,
            payload: { key: brandKey, theme }
        });
    };
};
